import cn from 'classnames';
import type { FC } from 'react';
import type { FieldError } from 'react-hook-form';
import { PasscodeControlled, PasswordControlled, PhoneControlled } from '../InputsControlled';
import TextControlled from '../InputsControlled/TextControlled';
import * as st from './styles.module.scss';

interface Props {
  type: 'passcode' | 'password' | 'phonenumber' | 'text';
  name: string;
  control?: any;
  error?: FieldError | undefined;
  disabled?: boolean;
  label?: string | undefined;
  showPassword?: boolean | undefined;
  setValue?: () => void;
  tabindex: number;
  variant?: 'outline' | 'online' | undefined;
  wrapperClassName?: string;
  autoComplete?: boolean;
  placeholder?: string;
  onChange?: () => void;
}

const CustomInput: FC<Props> = ({
  name,
  error,
  type,
  control,
  disabled,
  showPassword,
  label = '',
  setValue,
  tabindex,
  variant,
  wrapperClassName,
  autoComplete,
  placeholder,
  onChange,
}) => {
  return (
    <>
      <div className={cn(st.wrapper, wrapperClassName)}>
        <div className={st.wrapper__input}>
          {type === 'passcode' && (
            <PasscodeControlled
              tabindex={tabindex}
              control={control}
              disabled={disabled}
              error={!!error?.message}
            />
          )}

          {type === 'phonenumber' && (
            <PhoneControlled
              onValueChange={onChange}
              tabindex={tabindex}
              name={name}
              control={control}
              disabled={disabled}
              error={!!error?.message}
              label={label}
              variant={variant}
            />
          )}
          {type === 'password' && (
            <PasswordControlled
              onChange={onChange}
              name={name}
              control={control}
              disabled={disabled}
              error={!!error?.message}
              label={label}
              showPassword={showPassword}
              setValue={setValue}
              autoComplete={autoComplete}
            />
          )}

          {type === 'text' && (
            <TextControlled
              onChange={onChange}
              placeholder={placeholder}
              tabindex={tabindex}
              name={name}
              control={control}
              disabled={disabled}
              error={!!error?.message}
              label={label}
              variant={variant}
            />
          )}
        </div>
        {/* <div className={st.wrapper__errorMessage}>{error && <p>{error?.message}</p>}</div> */}
      </div>
    </>
  );
};

export default CustomInput;
